import { SERVICE_NAMES } from '../../../../constants/serviceNames';
import { IPublishTermsServices } from '../../../../redux/reducers';
import { ITermSchema, EServiceType } from '../internalTypes';
import { getServiceId } from './getServiceId';
import { mapPublishOptions } from './mapPublishOptions';

export function mapServices(terms: ITermSchema[]): IPublishTermsServices {
  return terms.reduce((acc, term) => {
    const { services } = term;
    const serviceId = getServiceId(term);
    const publishOptions = mapPublishOptions(term.publishOptions);

    /* FIXME: Сейчас под highlight мы отображаем "Платное с выделением цветом".
       Выпилить, когда доработают бэк. */
    const mappedServices = serviceId === EServiceType.highlight
      ? [EServiceType.paid, EServiceType.highlight]
      : services;

    acc[serviceId] = {
      ...term,
      id: serviceId,
      name: SERVICE_NAMES[serviceId] || term.name,
      publishOptions,
      services: mappedServices,
    };

    return acc;
  }, {} as IPublishTermsServices);
}
